export default __webpack_public_path__ + "pdf/politika_konfiden.0114fe39.pdf";